import React from "react";
import { FaYoutube, FaWhatsapp } from "react-icons/fa";

function Socials() {
  return (
    <div className="fixed right-5  bottom-0 -translate-y-1/2 z-50 flex  gap-1">
      
      {/* YouTube Button */}
      <a
        href="https://www.youtube.com/@MapleCloudTechnologies"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-red-600 hover:bg-red-700 w-32 h-8 rounded-full flex items-center justify-center gap-3 text-white font-bold text-sm shadow-lg transition duration-300 hover:scale-105"
      >
        <FaYoutube className="text-xl" />
        YouTube
      </a>

      {/* WhatsApp Button */}
      <a
        href="https://api.whatsapp.com/send/?phone=918178803636&text=Hello+MapleCloud+team&type=phone_number&app_absent=0"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-500 hover:bg-green-600 w-32 h-8 rounded-full flex items-center justify-center gap-3 text-white font-bold text-sm shadow-lg transition duration-300 hover:scale-105"
      >
        <FaWhatsapp className="text-xl" />
        WhatsApp
      </a>
    </div>
  );
}

export default Socials;